import { LinearGradient, Stack } from '@adc/parallax-component-library';

import { buildTestId } from '~/utils/buildTestId';

type Props = {
  testID: string;
};

export const LactateLogoGradient = ({ testID }: Props) => (
  <Stack testID={testID}>
    <LinearGradient
      testID={buildTestId({ testID, suffix: 'gradient' })}
      colors={['#4E9FF8', '#007AFF']}
      start={{ x: 0, y: 0 }}
      end={{ x: 0, y: 1 }}
      borderRadius="$1.25"
      overflow="hidden"
      marginLeft={10}
      marginRight={14}
    >
      <Stack width={31} height={31} />
    </LinearGradient>
  </Stack>
);
